<style scoped lang="scss">
.error-page-container{
  width: 920px;
  margin: 200px auto;

  .left-part{
    float: left;
    margin-right: 50px;
  }

  .right-part{
    float: left;

    .text{
      font-size: 22px;
      margin-top: 30px;
      color: #353535;
    }

    .back-btn{
      margin-top: 60px;
    }
  }
}
</style>

<template>
<div>
  <div class="error-page-container">
    <img class="left-part" src="static/img/404.png"></img>
    <div class="right-part">
      <!-- <div class="text">抱歉，您访问的页面飘走啦...</div> -->
      <div class="text">抱歉，您访问的链接地址有误，请重新查找或刷新页面试一试！</div>

      <el-button type="primary" class="back-btn" @click="gohome()">返回首页</el-button>
      <!-- <el-button type="primary" class="back-btn" @click="goback()">刷新页面</el-button> -->
    </div>
  </div>
</div>
</template>

<script>
export default{
  methods: {
    goback: function () {
      window.history.go(-1)
    },
    gohome: function () {
      window.location.href = '/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// 404.vue?360cd6b7